import React from 'react'

export default function SearchSuggestionsSkeleton({ count = 4 }: { count?: number }) {
    return (
        <ul
            className="space-y-2.5 max-h-[min(50vh,22rem)] overflow-y-auto pr-1 md:max-h-[min(60vh,28rem)]"
            aria-hidden
        >
            {Array.from({ length: count }).map((_, i) => (
                <li key={i} className="flex min-w-0 items-center gap-2">
                    <div className="h-4 w-4 shrink-0 rounded-sm bg-muted-color/50 animate-pulse" />
                    <div
                        className="h-4 max-w-full rounded bg-muted-color/45 animate-pulse"
                        style={{ width: `${Math.min(280, 132 + ((i * 23) % 118))}px` }}
                    />
                </li>
            ))}
        </ul>
    )
}
